var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M4.599,11.071l2.773-4.16.693.462-2.773,4.16-.693-.462ZM5.639,11.764l2.773-4.16.693.462-2.773,4.16-.693-.462ZM6.679,12.458l2.773-4.16.693.462-2.773,4.16-.693-.462Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M19.854,21.24l2.773-4.16.693.462-2.773,4.16-.693-.462ZM20.894,21.934l2.773-4.16.693.462-2.773,4.16-.693-.462ZM21.934,22.627l2.773-4.16.693.462-2.773,4.16-.693-.462Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.894,18.929l3.467,2.311",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.448,
    y: 17.999,
    width: 0.417,
    height: 4.167,
    transform: "translate(-6.621 27.795) rotate(-56.312)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.84,12.227c1.532-2.298,4.636-2.919,6.934-1.387s2.919,4.636,1.387,6.934l-8.321-5.547Z",
    style: {
      fill: "#cd2e3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.84,12.227c-1.532,2.298-.911,5.402,1.387,6.934,2.298,1.532,5.402.911,6.934-1.387.766-1.149.455-2.701-.693-3.467-1.149-.766-2.701-.455-3.467.693l-4.161-2.773Z",
    style: {
      fill: "#0047a0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.92,
    cy: 13.613,
    r: 2.5,
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M7.373,23.089l-2.773-4.16.693-.462,2.773,4.16-.693.462ZM8.413,22.396l-2.773-4.16.693-.462,2.773,4.16-.693.462ZM9.453,21.703l-2.773-4.16.693-.462,2.773,4.16-.693.462Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M22.627,12.92l-2.773-4.16.693-.462,2.773,4.16-.693.462ZM23.667,12.227l-2.773-4.16.693-.462,2.773,4.16-.693.462ZM24.707,11.533l-2.773-4.16.693-.462,2.773,4.16-.693.462Z",
    style: {
      fill: "#000000"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.853,20.431l1.04-.693M20.894,11.071l1.213-.809M23.147,9.569l1.04-.693"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.968,20.605l-.231-.347,1.04-.693.231.347-1.04.693ZM21.009,11.244l-.231-.347,1.213-.809.231.347-1.213.809ZM23.263,9.742l-.231-.347,1.04-.693.231.347-1.04.693Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/KR.6810380d8680ae5b3ad14823e5903c2f.svg";
export { ForwardRef as ReactComponent };